import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import type { PropsWithChildren } from 'react';

import { brand } from './brand.js';

const theme = createTheme({
  palette: {
    primary: { main: brand.primary, dark: brand.primaryDark, contrastText: '#fff' },
    secondary: { main: brand.secondary, dark: brand.secondaryHover, contrastText: '#fff' },
    success: { main: brand.success },
    error: { main: brand.error },
    background: { default: brand.pageBackground, paper: '#fff' },
    text: { primary: brand.textHeader, secondary: brand.textBody },
    divider: brand.border,
  },
  // Matches --radius-m on their site.
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Mozaic GEO Variable", Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
    h1: { fontSize: '2rem', fontWeight: 750, letterSpacing: '-0.025em', color: brand.textHeader },
    h2: { fontSize: '1.35rem', fontWeight: 700, color: brand.textHeader },
    button: { textTransform: 'none', fontWeight: 650 },
  },
  components: {
    MuiButtonBase: { defaultProps: { disableRipple: true } },
    MuiCard: {
      styleOverrides: {
        // Their --shadow-m.
        root: { boxShadow: '0 0 24px 0 rgba(0,0,0,0.06)', border: `1px solid ${brand.border}` },
      },
    },
    MuiLink: { styleOverrides: { root: { color: brand.link } } },
  },
});

export function AppThemeProvider({ children }: PropsWithChildren): React.JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
